import React, { useState, useEffect, useMemo } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router'
import { Badge, Button, CircularProgress, Container, Typography, useMediaQuery } from '@mui/material'

import { mainApi } from '../../../../store/services/mainApi'
import { Box } from '@mui/material'

import { useTranslation } from 'react-i18next'
import StyledBox from './../../StyledBox/StyledBox';
import ShareIcon from '@mui/icons-material/Share';
import FacturaDownloadModal from '../../components/FacturaDownloadModal/FacturaDownloadModal'
import dayjs from 'dayjs'


export default function FacturaPage() {
  const [tradeName, setTradeName] = useState('')
  const navigate = useNavigate()

  //localization
  const { t } = useTranslation()
  const mobileView = useMediaQuery('(max-width: 798px)')

  const [viewOrder, setViewOrder] = useState(false)
  const [viewOrderId, setViewOrderId] = useState('')

  const location = useLocation()
  
  const tradeNameParams = useParams()?.tradeName ;
  const idParams = useParams().id;
  const {
    data: contact,
    isLoading,
    isError,
  } = mainApi.useGetBuisnessContactByTradeNameQuery(tradeNameParams, {
    skip: !tradeNameParams,
  })

  const [openDummy, setOpenDummy] = useState(false)
  const [facturaDownloadRow, setFacturaDownloadRow] = useState(null)
  const [pdfName, setPdfName] = useState('')

  const setValuesForPdf = (value) => {
    setOpenDummy(true)
    setPdfName(`${value.cliente}/${value.fetcha.toISOString()}.pdf`)
    setFacturaDownloadRow({
      ...value,
      orders: value.orders,
      fetcha: value.fetcha,
      tradeName: value?.contact?.tradeName,
    })
  }
  const {
    data: facturas,
    isLoading: isLoadingFacturas,
    isFetching: isFetchingFacturas,
  } = mainApi.useGetFacturasByClientQuery(
    { tradeName: contact?.tradeName },
    {
      skip: !contact,
    },
  )

  const [foundFactura, setFoundFactura] = useState({})

  useEffect(() => {
    if (!isLoading && facturas) {
      setFoundFactura(facturas.find((item) => item._id == idParams))
    }
  }, [facturas, idParams, isLoading])

  useEffect(() => {
    if (tradeName === null || tradeName === undefined) {
      console.log('tradeName is null or undefined.')
    } else if (tradeName === 'VPF') {
      fetch('https://tpomobi.shop/getOrdersAdmin?tradeName=VPF', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => response.json()).then((error) => {
        console.error('Error:', error)
      })
    }
  }, [tradeName])

  useEffect(() => {
    if (contact) {
      // document.title = `${contact.name}`
      const favicon = document.querySelector("link[rel*='icon']") || document.createElement('link')
      favicon.rel = 'icon'
      favicon.href = `${contact.img}`
      document.head.appendChild(favicon)
    }
  }, [contact])


  const [rows, setRows] = useState([])

  useEffect(() => {
    if (contact) {
      setTradeName(contact?.tradeName || '')
      document.title = contact?.name ? contact?.name + `(${contact?.tradeName ? contact?.tradeName : 'N/A'})` : 'Static Page'
      // console.log(contact)
    }
  }, [contact])

  const [rowSelectionModel, setRowSelectionModel] = useState([])

  const balance = useMemo(() => {
    if (foundFactura) {
      return parseFloat(foundFactura?.paidValue)
        ? (
            (parseFloat(foundFactura?.deliveryPrice) ? parseFloat(foundFactura.deliveryPrice) : 0) +
            foundFactura.items
              ?.map((items) => (items.marketPriceCP != '' ? parseFloat(items.marketPriceCP * (items.quantity || 1)) : 0))
              ?.reduce((acc, curr) => acc + curr, 0)
              ?.toFixed(2) -
            (parseFloat(foundFactura?.paidValue)?.toFixed(2) || 0)
          )?.toFixed(2)
        : (
            (parseFloat(foundFactura?.deliveryPrice) ? parseFloat(foundFactura.deliveryPrice) : 0) +
            foundFactura.items
              ?.map((items) => (items.marketPriceCP != '' ? parseFloat(items.marketPriceCP * (items.quantity || 1)) : 0))
              ?.reduce((acc, curr) => acc + curr, 0)
          )?.toFixed(2)
    }
  }, [foundFactura])
  const [creationDate, setCreationDate] = useState('')
  const [creationTime, setCreationTime] = useState('')
  const [items, setItems] = useState([])

  useEffect(() => {
    if (foundFactura) {
      document.title = `Order ${foundFactura._id?.slice(-6)} ${foundFactura?.tradeName || foundFactura.userAcc?.tradeName || 'No TradeName'}`
      
      setItems(foundFactura.items)

      setCreationDate(dayjs(foundFactura?.fetcha).format('DD/MM/YYYY'))
      setCreationTime(dayjs(foundFactura?.fetcha).format('HH:mm'))
    }
  }, [foundFactura])

  return isLoading ? (
    <Container>
      <CircularProgress />
    </Container>
  ) : isError ? (
    <Container sx={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Typography variant='h1' sx={{ textAlign: 'center', fontFamily: 'Inter' }} color={'error'}>
        Error: check u user id is correct or not. User id: {location.pathname.split('/').pop()}
      </Typography>
    </Container>
  ) : (
    <div className='staticPage'>

      <StyledBox defaultVisible={true} sx={{ width: 'max-content', minWidth: '300px', maxWidth: '100%' }}>
          <div className='orderInfo__box__item'>
            <p>
              Number: <span>{foundFactura?.num ? foundFactura.num : foundFactura?._id ? foundFactura?._id.slice(-6) : ''}</span>
            </p>
          </div>

          <div className='orderInfo__box__item'>
            <p>
              Name:{' '}
              <span>
                {foundFactura?.contact?.name}
              </span>
            </p>
          </div> 
          <div className='orderInfo__box__item'>
            <p>
              Debt: <span style={{ color: (parseFloat(foundFactura.estada)) <= 0 ? 'green' : 'red', textAlign: 'right' }}>{parseFloat(foundFactura.estada).toFixed(2)}€</span>
            </p>
          </div>
          <div className='orderInfo__box__item'>
            <p>
              Total: <span>{(parseFloat(foundFactura?.total) ? parseFloat(foundFactura?.total).toFixed(2) : '0.00') + '€'}</span>
            </p>
          </div>
          <div className='orderInfo__box__item'>
            <p>
              Paid: <span>{(parseFloat(foundFactura?.payValue) ? parseFloat(foundFactura?.payValue).toFixed(2) : '0.00') + '€'}</span>
            </p>
          </div>
          <div className='orderInfo__box__item'>
            <p>
              CREATION:{' '}
              <span>
                {creationDate} {creationTime}
              </span>
            </p>
          </div>
          <div className='orderInfo__box__item'>
            <p>
              TOTAL ITEMS: <span>{items ? items?.length : 0}</span>
            </p>
          </div>
          <div className='orderInfo__box__item' style={{ backgroundColor: foundFactura?.status?.color, color: 'white', padding: '0px 5px', borderRadius: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <p>
              Status: <span>{foundFactura?.status ? foundFactura.status?.name : 'No Status'}</span>
            </p>
          </div>
        </StyledBox>

      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: mobileView ? 'column' : 'row', gap: '10px' }}>
        <Button
          sx={{
            m: 2,
            width: mobileView ? '100%' : '300px',
            height: '60px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            fontSize: '14px',
            fontFamily: 'Archivo Black',
            background: '#5FC56E',
            borderRadius: '8px'
          }}
          variant='contained'
          disabled={isLoadingFacturas}
          onClick={() => { 
            if (idParams) {
              setValuesForPdf({ ...foundFactura, id: foundFactura._id, fetcha: new Date(foundFactura.fetcha) })
            } else {
              alert('Error in load facturas')
            }
          }}
          // color='success'
        >
          Descargar Facturas
        </Button>
      </Box>
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: mobileView ? 'column' : 'row', gap: '10px' }}>
        <Button
          sx={{
            m: 2,
            width: mobileView ? '100%' : '300px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            fontSize: '14px',
            fontFamily: 'Archivo Black',
            background: '#3e8949',
            borderRadius: '8px'
          }}
          variant='contained'
          onClick={() => { 
            navigate(`/account/${tradeName}`)
          }}
          // color='success'
        >
          Historial de las Facturas 
        </Button>
      </Box>
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', flexDirection: mobileView ? 'column' : 'row', gap: '10px' }}>
        <Button
          sx={{
            m: 2,
            width: '16px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            fontSize: '14px',
            fontFamily: 'Archivo Black',
            background: '#3e8949',
            borderRadius: '8px'
          }}
          variant='contained'
          onClick={async () => { 
            if (navigator.share) {
              try {
                await navigator.share({
                  title: 'facturas link',
                  url: window.location.href,
                })
              } catch (error) {
                console.error('Error sharing:', error);
              }
            } else {
              console.log('Web Share API is not supported');
              navigator.clipboard.writeText(window.location.href)  
            }
          }}
          // color='success'
        >
          <ShareIcon/>
        </Button>
      </Box>


      <FacturaDownloadModal
        open={openDummy}
        onClose={() => setOpenDummy(false)}
        facturaRow={facturaDownloadRow}
        pdfName={pdfName}
      />

    </div>
  )
}